import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import ReviewScore from '../utilities/ReviewScore';
import softieImg from '../../../assets/softie.PNG';

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

export class Review extends Component {
  constructor(props) {
    super(props);

    this.db = firebase.firestore();
    this.handleSoftieClick = this.handleSoftieClick.bind(this);

    this.state = {
      softies: this.props.reviewData.softies,
      userLikes: this.props.reviewData.userLikes,
      softieGiven: this.props.reviewData.userLikes.includes(
        this.props.userEmail
      ),
      softieButtonDisabled: false,
    };
  }
  componentDidMount() {
    console.log(this.props.reviewData);
  }

  handleSoftieClick() {
    let ref = this.db
      .collection('software_pages')
      .doc(this.props.prodId)
      .collection('reviews')
      .doc(this.props.reviewData.revId);

    this.setState({
      softieGiven: !this.state.softieGiven,
      softieButtonDisabled: true,
    });

    return this.db
      .runTransaction(transaction => {
        // This code may get re-run multiple times if there are conflicts.
        return transaction.get(ref).then(doc => {
          if (!doc.exists) {
            console.log('Document does not exist!');
          } else {
            var newSofties = this.state.softieGiven
              ? doc.data().softies + 1
              : doc.data().softies - 1;
            var newUserLikes = this.state.softieGiven
              ? doc.data().userLikes.concat(this.props.userEmail)
              : doc
                  .data()
                  .userLikes.filter(uId => uId !== this.props.userEmail);
            this.setState({ softies: newSofties, softieButtonDisabled: false }); // Update the state as well
            transaction.update(ref, {
              softies: newSofties,
              userLikes: newUserLikes,
            });
          }
        });
      })
      .then(() => {
        console.log('Transaction successfully committed!');
      })
      .catch(error => {
        console.log('Transaction failed: ', error);
      });
  }

  render() {
    let softieClass = this.state.softieGiven ? 'softieGiven' : 'softieNotGiven';

    return (
      <div>
        <Card>
          <Card.Header style={headerMain}>
            <ReviewScore
              size="small"
              rating={this.props.reviewData.revRating}
            />
            <div style={softieTopRightStyle}>
              <div>
                <b style={{ fontSize: '2.1em' }}>
                  {' '}
                  {this.state.softies}{' '}
                  <input
                    type="image"
                    id="image"
                    alt="Give Softie"
                    width="32"
                    height="45px"
                    disabled={this.state.softieButtonDisabled}
                    style={softieStyle}
                    className={softieClass}
                    src={softieImg}
                    onClick={this.handleSoftieClick}
                  />
                </b>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            <Card.Title> {this.props.reviewData.revTitle} </Card.Title>
            <p style={{ margin: '0px 0px 22px 0px' }}>
              {' '}
              {this.props.reviewData.revDetails}{' '}
            </p>
            <Card.Title>Feedback</Card.Title>
            {this.props.reviewData.revFeedback}
          </Card.Body>
        </Card>
      </div>
    );
  }
}

const headerMain = {
  position: 'relative',
};

const softieTopRightStyle = {
  position: 'absolute',
  top: '50%',
  right: '1%',
  msTransform: 'translate(-0.5%, -50%)',
  transform: 'translate(-0.5%, -50%)',
  outline: 'none',
  padding: '5px',
};

const softieStyle = {
  verticalAlign: 'middle',
};

export default Review;
